<script lang="ts">
	import type { Device } from 'src/types/Device';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { real_id, is_gen_2 } from 'src/helpers/interface_helpers';
	import ControlDirectionDevicePageV2 from 'src/components/Controls/Single/ControlDirectionDevicePageV2.svelte';
	import ControlDirectionDevicePageG2V2 from 'src/components/Controls/Single/ControlDirectionDevicePageG2V2.svelte';
	import DeviceViewStateWrapper from 'src/components/Sidepanel/DeviceViews/DeviceViewStateWrapper.svelte';
	import DeviceNotificationLabel from 'src/components/Sidepanel/DeviceNotificationLabel.svelte';
	import { devices_config } from 'src/configs/devices';
	import {
		createGen1StatusLabels,
		getGen1DeviceStatuses,
	} from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Shelly/Gen1/gen1-main-helpers';
	import DeviceLabelList from '../DeviceLabelList.svelte';

	export let device: Device;

	$: isGen2 = is_gen_2(device);

	$: statusStore = getDeviceStatus(device?.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device?.id);
	$: settings = $settingsStore;

	$: deviceConfig = devices_config?.[device?.type];
	$: _statuses = getGen1DeviceStatuses(status, device, settings, deviceConfig);
	$: labelList = createGen1StatusLabels(_statuses);
</script>

<DeviceViewStateWrapper {device}>
	<div slot="staticTop">
		<DeviceLabelList {labelList} />
		<DeviceNotificationLabel deviceId={device?.id} />
	</div>
	<div class="flex-full-height justify-content-end" slot="staticBottom">
		{#if isGen2}
			<ControlDirectionDevicePageG2V2 {device} {status} />
		{:else}
			<ControlDirectionDevicePageV2 {device} {status} />
		{/if}
	</div>
</DeviceViewStateWrapper>
